import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

export const createBulkUploadJob = async ({ formData }) => {
  const { data } = await apiClient.post('/bulk-uploads', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const useCreateBulkUploadHandler = (onCancel, redirectAfterSubmit) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: createBulkUploadJob,
    onSuccess: () => {
      dispatch(showSnackbar({ message: "File uploaded successfully!", severity: 'success' }));
      queryClient.invalidateQueries({ queryKey: ['bulk_uploads'] });
      if (onCancel) onCancel();
      if (redirectAfterSubmit) navigate(redirectAfterSubmit);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        dispatch(
            showSnackbar({
              message: error.response?.data?.message || "Error uploading the selected file. Please try again later",
              severity: 'error',
            }),
        );
      } else {
        dispatch(showSnackbar({ message: "Unexpected error occurred. Please try again.", severity: 'error' }));
      }
    },
    onSettled: () => {
      setLoading(false);
    },
  });

  const onSubmit = async (file, category, subCategory, selectedTemplate) => {
    setLoading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('templateName', selectedTemplate);
    formData.append('category', category);
    formData.append('subCategory', subCategory);

    mutation.mutate({ formData });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: mutation.error,
    isPending: mutation.isPending || loading,
    isSuccess: mutation.isSuccess,
    onSubmit,
  };
};